
import { StyleSheet } from 'react-native';

export const nativeStyles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#0C0D0E',
    paddingHorizontal: 20,
  },
  welcomeText: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#ffffff',
    textAlign: 'center',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 18,
    color: '#b0b0b0',
    textAlign: 'center',
    marginBottom: 20,
  },
  nameText: {
    fontSize: 18,
    color: '#ffffff',
    textAlign: 'center',
    marginBottom: 10,
    fontWeight: '600',
  },
  emailText: {
    fontSize: 16,
    color: '#888888',
    textAlign: 'center',
    marginBottom: 10,
  },
  providerText: {
    fontSize: 14,
    color: '#4A9EFF',
    textAlign: 'center',
    marginBottom: 40,
    fontStyle: 'italic',
  },
  logoutButton: {
    backgroundColor: '#ff4757',
    paddingHorizontal: 30,
    paddingVertical: 15,
    borderRadius: 25,
    elevation: 4,
    width: '100%',
    maxWidth: 300,
  },
  logoutButtonText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'center',
  },
  profileSection: {
    marginBottom: 30,
    alignItems: 'center',
  },
  statsSection: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 30,
    width: '100%',
    paddingHorizontal: 10,
  },
  statCard: {
    backgroundColor: '#2A2A2A',
    padding: 12,
    borderRadius: 10,
    alignItems: 'center',
    minWidth: 70,
    elevation: 2,
  },
  statNumber: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#4A9EFF',
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 11,
    color: '#b0b0b0',
    textAlign: 'center',
  },
  actionsSection: {
    width: '100%',
    marginBottom: 30,
  },
  actionButton: {
    backgroundColor: '#2A2A2A',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 10,
    marginBottom: 10,
    elevation: 2,
  },
  actionButtonText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
  },
});

export const nativeAuthStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#0C0D0E',
  },
  scrollContainer: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingHorizontal: 20,
    paddingVertical: 40,
  },
  header: {
    alignItems: 'center',
    marginBottom: 40,
  },
  title: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#ffffff',
    textAlign: 'center',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    color: '#b0b0b0',
    textAlign: 'center',
  },
  form: {
    width: '100%',
    writingDirection: 'rtl',
    backgroundColor: '#1A1B1E',
    padding: 30,
    borderRadius: 20,
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#111113',
    borderRadius: 15,
    paddingHorizontal: 18,
    paddingVertical: 16,
    marginBottom: 18,
    writingDirection: 'rtl',
  },
  inputContainerFocused: {
    backgroundColor: '#111113',
  },
  inputIcon: {
    marginLeft: 12,
  },
  inputIconFocused: {
    color: '#4A9EFF',
  },
  input: {
    flex: 1,
    fontSize: 16,
    color: '#ffffff',
    textAlign: 'right',
    backgroundColor: 'transparent',
  },
  eyeIcon: {
    padding: 4,
  },
  optionsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 28,
    paddingHorizontal: 4,
  },
  rememberMeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  rememberMeText: {
    marginRight: 10,
    fontSize: 14,
    color: '#b0b0b0',
    fontWeight: '500',
  },
  circularCheckbox: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#4A9EFF',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  circularCheckboxChecked: {
    backgroundColor: '#4A9EFF',
    borderColor: '#4A9EFF',
  },
  forgotPasswordText: {
    fontSize: 14,
    color: '#4A9EFF',
    fontWeight: '500',
  },
  primaryButton: {
    backgroundColor: '#4A9EFF',
    borderRadius: 15,
    paddingVertical: 18,
    alignItems: 'center',
    marginBottom: 25,
  },
  primaryButtonText: {
    color: '#ffffff',
    fontSize: 17,
    fontWeight: '700',
  },
  divider: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 25,
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: '#333333',
  },
  dividerText: {
    marginHorizontal: 20,
    fontSize: 14,
    color: '#b0b0b0',
    fontWeight: '500',
  },
  socialButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
    gap: 35,
  },
  socialButton: {
    backgroundColor: '#111113',
    borderRadius: 50,
    width: 70,
    height: 70,
    justifyContent: 'center',
    alignItems: 'center',
  },
  footer: {
    marginTop: 25,
    alignItems: 'center',
  },
  topFooter: {
    marginBottom: 25,
    paddingBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#333333',
    alignItems: 'center',
  },
  footerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    writingDirection: 'rtl',
  },
  footerText: {
    fontSize: 14,
    color: '#b0b0b0',
    marginRight: 16,
  },
  switchText: {
    fontSize: 14,
    color: '#4A9EFF',
    fontWeight: '600',
  },
  switchButton: {
    backgroundColor: '#111113',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    marginLeft: 8,
    borderWidth: 1,
    borderColor: '#18191B',
  },
  switchButtonText: {
    fontSize: 14,
    color: '#4A9EFF',
    fontWeight: '600',
  },
});
